import { Component, Ref, Watch } from 'vue-property-decorator';
import { Getter, Action, Mutation } from 'vuex-class';

import { AnchorableContentBlockViewModel } from './AnchorableContentModule.types';
import { getComponentProps } from '@/utils/vueUtils';
import SizeBreakpoints from '@/common/interfaces/SizeBreakpoints';
import GenericComponent from '@/components/GenericComponent/GenericComponent.vue';
import { Affix } from 'vue-affix';
import Chevron from '@/assets/icons/chevron.svg?inline';

import { M_SET_ANCHORABLE_CONTENT } from '@/store/mutations';
import LinkItem from '@/common/interfaces/LinkItem';
import { ObserveVisibility } from 'vue-observe-visibility';

import {
  isInBreakpoint,
  windowOffset,
  windowSize,
  windowWidth,
  currentUri,
  anchorBarLinks,
  anchorBarOffset,
} from '@/store/getters';
import {
  CURRENT_ANCHOR_HASH,
  SET_ANCHOR_HASH_VISIBLE,
  SET_FROM_ANCHORABLE_CONTENT,
} from '@/store/modules/groupUriModule';
import { mixins } from 'vue-class-component';
import GroupUriMixin from '@/mixins/GroupUriMixin';
import { matchMediaWindow } from '@/utils/domUtils';

@Component({
  components: {
    GenericComponent,
    Chevron,
    Affix,
  },
  directives: {
    ObserveVisibility
  },
  props: getComponentProps<AnchorableContentBlockViewModel>({
    TopText: {
      Type: 'ContentTextGenericBlock',
      Item: {
        Text: '<p>Top block content</p>',
        IsDropLetter: false,
        IsCentered: false,
        IsQuoteCenter: false,
      },
    },
    hideLinkNumber: true,
    Items: [
      {
        Id: 'ItemContentId',
        AnchorTitle: 'Information Collected',
        InnerBlocks: [
          {
            Type: 'ContentAccordionButtonBlock',
            Item: {
              Action: 'Button',
              Title: 'label',
              Link: 'link',
              ButtonStyle: 2,
            },
          },
          {
            Type: 'ContentTextGenericBlock',
            Item: {
              Text: '<p>Test</p>\n<p>text</p>\n<p>html </p>\n<p>as</p>',
              IsDropLetter: false,
            },
          },
          {
            Type: 'ContentAccordionPhoneBlock',
            Item: {
              Action: 'Phone',
              Title: '0312021',
              Link: 'LINK',
              ButtonStyle: 1,
            },
          },
        ],
      },
    ],
  }),
})
export default class AnchorableContentModule extends mixins(GroupUriMixin) {
  p!: AnchorableContentBlockViewModel;
  //TODO check is Wishlist a props or not?
  wishlist = false;
  isOpen = false;
  offsetTop = null;

  @Ref('navbar') readonly navbar!: HTMLElement;

  @Getter(isInBreakpoint) isInBreakpoint!: (
    breakpoints: SizeBreakpoints[] | SizeBreakpoints,
  ) => boolean;
  @Getter(windowOffset) windowOffset!: number;
  @Getter(windowSize) windowSize!: SizeBreakpoints;
  @Getter(windowWidth) windowWidth!: number;
  @Getter(CURRENT_ANCHOR_HASH) getCurrentHash!: string;
  @Getter(currentUri) currentUri!: string;
  @Getter(anchorBarLinks) anchorBarLinks!: LinkItem[];

  @Action(SET_FROM_ANCHORABLE_CONTENT) setLink!: (link: string) => void;
  @Getter(anchorBarOffset) anchorBarOffset: number;
  @Action(SET_ANCHOR_HASH_VISIBLE) setVisible: (anchorHash: string) => void;

  @Watch(windowWidth)
  windowWidthChanged() {
    this.orientationChange();
  }

  get scrollOffsetPos() {
    return {
      top: 65,
      bottom: 20,
    };
  }

  getOffsetTop() {
    this.offsetTop = this.navbar.offsetTop;
  }

  get showDropdown() {
    return this.isInBreakpoint(['xs', 'sm']);
  }

  formatIndex(index: number) {
    return (index + 1).toString().padStart(2, '0');
  }

  scrollToLink(link: string) {
    this.isOpen = false;
    this.setLink(link);
  }

  get linksWithoutSlash() {
    return this.p.Items.map(item => {
      return {
        ...item,
        fullLink: `${window.location.pathname.replace(/\/$/, '')}#${item.Id}`
      }
    })
  }

  orientationChange() {
    if (this.isInBreakpoint(['xs', 'sm', 'md'])) {
      if (matchMediaWindow('(orientation: landscape)')) {
        this.getOffsetTop();
      }
    } else {
      return;
    }
  }

  @Mutation(M_SET_ANCHORABLE_CONTENT) notify!: () => void;

  mounted() {
    const hash = new URL(document.URL).hash.slice(1);
    this.notify();
    this.getOffsetTop();
    setTimeout(() => this.scrollToLink(hash), 1000);
    // @ts-ignore
    this.$refs.anchorableContentNavInner.$el.style.top = '';
  }

  get isLongList() {
    return this.linksWithoutSlash.length >= 15;
  }

  get anchorList() {
    return this.p.Items?.map((item) => ({
      AnchorHash: item.Id,
      IsVisible: item.Id === this.getCurrentHash,
    }));
  }

  getVisibilityIOOptions(anchorHash: string) {
    const intersectionParams: IntersectionObserverInit = {
      threshold: [0],
      rootMargin: `${this.anchorBarOffset}px 0px 0px 0px`,
    };

    return {
      callback: (isVisible, entry) => {
        this.anchorList.find((a) => a.AnchorHash === anchorHash).IsVisible = isVisible;
        const firstVisible = this.anchorList.find((a) => a.IsVisible);

        if (firstVisible) {
          this.setVisible(firstVisible.AnchorHash);
        }
      },
      throttle: 100,
      throttleOptions: {
        leading: 'visible',
      },
      intersection: intersectionParams,
    };
  }
}
